import { render, staticRenderFns } from "./port.vue?vue&type=template&id=84f8e282&scoped=true&"
import script from "./port.vue?vue&type=script&lang=js&"
export * from "./port.vue?vue&type=script&lang=js&"
import style0 from "./port.vue?vue&type=style&index=0&id=84f8e282&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f8e282",
  null
  
)

export default component.exports